import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"17px","color":"#303133"} }, "确认加入", -1)
const _hoisted_2 = { class: "com-na-1" }
const _hoisted_3 = { style: {"font-weight":"700"} }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "是否确定加入", -1)
const _hoisted_6 = { class: "com-na" }
const _hoisted_7 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue';
import {
  geCompanyIvite,
  agreeEnterCompany,
  getUseMemberPrivige,
  getUserDetail,
} from '@/api/api';
import { createStore } from '@/vuex/store';
import { useRouter, useRoute } from 'vue-router';
import {
  getRouterName,
  isToken,
  handleConsoleMenuList,
  generateHomeMenuList,
} from './utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const isPhone = ref(false);

const store = createStore();
const inviteUrlDialog = ref(false);
const companyName = ref<string>('');
const companyCode = ref<string>('');
const inviteParam = ref<string>('');
isPhone.value = store.state.isPhone;
// watch(
//   () => store.state.inviteParam,
//   (newV) => {
//     if (newV && JSON.parse(localStorage.getItem('user')) && !JSON.parse(localStorage.getItem('user')).companyCode) {
//       inviteParam.value = newV
//       const msg = {
//         inviteParam: newV,
//       };
//       geCompanyIvite(msg).then((res) => {
//         if (res.success) {
//           companyName.value = res.data.name;
//           inviteUrlDialog.value = true;
//           companyCode.value = res.data.code;
//         }
//       });
//     }
//   }
// );
const noticeDialog = ref<boolean>(false);
// watch(
//   () => route.path,
//   (newV) => {
//     if (
//       newV !== '/portal' &&
//       (!localStorage.getItem('onReadNotice') ||
//         localStorage.getItem('onReadNotice') === 'false')
//     ) {
//       noticeDialog.value = true;
//     }
//   }
// );
// const noticeDialog = ref<boolean>(true);
if (localStorage.getItem('inviteParam')) {
  if (
    localStorage.getItem('inviteParam') &&
    JSON.parse(localStorage.getItem('user')) &&
    !JSON.parse(localStorage.getItem('user')).companyCode
  ) {
    inviteParam.value = localStorage.getItem('inviteParam');
    const msg = {
      inviteParam: localStorage.getItem('inviteParam'),
    };
    geCompanyIvite(msg).then((res) => {
      if (res.success) {
        companyName.value = res.data.name;
        inviteUrlDialog.value = true;
        companyCode.value = res.data.code;
      }
    });
  }
}
function getUser() {
  if (!localStorage.getItem('token')) return;
  getUserDetail().then((res) => {
    if (res.success) {
      // store.action.setToken(res.data.token);
      store.action.updateUser(res.data.user);
    }
  });
}

// let relIcon = document.head.querySelector("link[rel='icon']");
// relIcon.href = 'https://g.csdnimg.cn/static/logo/favicon32.ico';
// document.title = '22'
if (store.state.user?.companyTabIconUrl) {
  let relIcon = document.head.querySelector("link[rel='icon']");
  relIcon.href = store.state.user.companyTabIconUrl;
}
if (store.state.user?.companyTabTitle) {
  document.title = store.state.user.companyTabTitle;
}
watch(
  () => store.state.user?.companyIconWordUrl,
  (newV) => {
    if (newV?.tabIconUrl) {
      let relIcon = document.head.querySelector("link[rel='icon']");
      relIcon.href = newV.companyTabIconUrl;
    }
    if (newV?.companyTabTitle) {
      document.title = newV.companyTabTitle;
    }
  },
  {
    deep: true,
  }
);
getUser();
function sureRead() {
  noticeDialog.value = false;
  localStorage.setItem('onReadNotice', 'read');
  getUser();
}
if (localStorage.getItem('token')) {
  getUseMemberPrivige().then((res: any) => {
    if (res.success) {
      // 更新用户权限信息
      store.action.updataUserPrivige(res.data);

      // 获取用户是否启用权限路由
      const userDetail = JSON.parse(localStorage.getItem('user') || '{}');
      const authorizedRoute = userDetail.authorizedRoute || false;

      // 生成并更新控制台菜单列表
      const consoloeMenuList = handleConsoleMenuList(res.data);
      store.action.updataRouterList(consoloeMenuList);

      // 生成并更新主页菜单列表
      const homeMenuList = generateHomeMenuList(res.data.memberGrade, authorizedRoute);
      store.action.updataHomeMenuList(homeMenuList);
    }
  });
}
function cancelJoin() {
  inviteUrlDialog.value = false;
  if (localStorage.getItem('inviteParam')) {
    localStorage.removeItem('inviteParam');
  }
  router.replace({
    path: '/console/factory',
  });
}

function sureJoin() {
  const msg = {
    inviteParam: inviteParam.value,
  };
  agreeEnterCompany(msg).then((res) => {
    if (res.success) {
      if (localStorage.getItem('inviteParam')) {
        localStorage.removeItem('inviteParam');
      }
      inviteUrlDialog.value = false;
      store.action.updateUserCompanyCode(companyCode.value);
      store.action.updateUserCompanyName(companyName.value);
      router.go(0);
      // getUseMemberPrivige().then((ret) => {
      //   if (ret.success) {
      //     sessionStorage.setItem('userPrivige', JSON.stringify(ret.data));
      //     const menuList = [
      //       {
      //         name: '创造',
      //         menu: [
      //           { name: '应用', routerName: 'myApp' },
      //           { name: '知识库', routerName: 'knowledgeBase' },
      //           { name: '插件', routerName: 'plugins' },
      //         ],
      //       },
      //       {
      //         name: '接入',
      //         menu: [{ name: '应用接入', routerName: 'openInterface' }],
      //       },
      //       {
      //         name: '管理',
      //         menu: [
      //           // { name: '返回首页', routerName: 'home' },
      //           { name: '我的账户', routerName: 'myCenter' },
      //         ],
      //       },
      //     ];
      //     if (ret.data.clientManage > 0) {
      //       menuList[1].menu.push({ name: '客户端', routerName: 'clients' });
      //     }
      //     if (ret.data.customerManage > 0) {
      //       menuList[1].menu.push({ name: '客服管理', routerName: 'chatManage' });
      //     }
      //     if (ret.data.memberNumber > 0) {
      //       menuList[2].menu.push({ name: '团队空间', routerName: 'teamSpace' });
      //     }
      //     store.action.updataRouterList(menuList);
      //   }
      // });
    }
  });
}
// const handleClickA = (event) => {
//   console.log(event.target.className);
// };
// const body = document.body;
// body.addEventListener('click', handleClickA);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: inviteUrlDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inviteUrlDialog).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      width: isPhone.value ? '90%' : '40%',
      class: "dia-p",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: cancelJoin }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: sureJoin,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_icon, { style: {"color":"#e6a23c","font-size":"22px","margin-right":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_WarningFilled)
            ]),
            _: 1
          }),
          _createTextVNode("是否确认加入 "),
          _createElementVNode("span", _hoisted_3, _toDisplayString(companyName.value), 1),
          _createTextVNode("的空间? ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: noticeDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((noticeDialog).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      "modal-class": 'right-top-dialog',
      width: isPhone.value ? '90%' : '40%'
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: sureRead,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("我知道了")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(companyName.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}
}

})